import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=0f53aa08"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"
import style0 from "./Configurations.vue?vue&type=style&index=0&id=0f53aa08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports